//components
import Nav from './components/Nav/Nav'
import Stays from './components/Stays/Stays'

function App() {
  return(
    <>
      <Nav/>
      <Stays/>
    </>
  )
}

export default App;

